import styled from 'styled-components';

const Content = styled.main`
  flex: auto;
  margin-left: ${(props) => (props.$hasSidebar ? ' 356px' : '0')};
`;

export default Content;
